<template>
    <div :class="classes">
        <slot name="wrapper" />
    </div>
</template>

<script>
export default {
	props: {
		wrapper: {
			type: String,
			required: false
		},

		results: {
			type: Boolean,
			required: false,
			default: false
		},

		calculations: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	computed: {
		classes() {
			return {
				'o-wrapper': true,
				'o-wrapper-results': this.results,
				'o-wrapper-calculations': this.calculations
			};
		}
	}
};
</script>

<style lang="scss">
.o-wrapper {
	&-results {
		display: block;
		overflow: hidden;
	}

	&-calculations {
		display: block;
		background-color: #fdfdfd;
		min-height: 100vh;
	}
}
</style>
